<template>  
    <section class="blockElement loginLoader-page">
        <div class="container-fluid bglogin p-0">
            <div class="innerInclude">
                <div class="p_login d-flex align-items-center justify-content-center p-0">
                    <div class="row w-100">
                        <div class="col-12 col-md-4  text-center d-flex vh_100 flex-wrap blueBG beforeBG justify-content-center align-items-center">
                            <div class="titleArera Loginlogo">
                                <img src="../../../../static/fxView/images/logo-white.svg" alt="Icon">
                            </div>
                            <div class="loginNewSection  ">
                                <div class="loginSpreads d-flex">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/Spreads.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent  text-left">
                                            <h3>Spreads</h3>
                                            <p>from 0.0 pips</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex ">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/Commission.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-right">
                                            <h3>$1 per</h3>
                                            <p>$100K Commission</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/TradingTools.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-left">
                                            
                                            <h3>A variety of </h3>
                                            <p>Trading Tools</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex ">
                                        <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/FastExecution.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-right">
                                            <h3>Ultra</h3>
                                            <p>Fast Execution</p>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/DepositBonus.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-left">
                                            <h3>100%</h3>
                                            <p>Deposit Bonus</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 
                            <div class="PortfoliosTitle"> 
                                <div id="demo" class="carousel slide fxRegisterSteps " data-ride="carousel"> 
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <p>{{ $t('welcomeMsg') }}</p>
                                            <img src="../../../../static/fxView/images/login-download.svg" alt="Banner">
                                            <h3>Competitive Trading Conditions </h3>
                                            <p>Benift from spreads as low as 0.0 pips on major fx pairs, and commission of $1 per $100,000 per side.</p>     
                                        </div>
                                         
                                    </div>
                                    <div class="clearfix"></div> 
                                </div>
                            </div>  -->
                            
                        </div>
                        <div class="col-12 col-md-8 text-center d-flex vh_100 align-items-center ">
                            <loader :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></loader>
                            
                            <div class="sign_insec text-left" v-if="!gAuthenticatorEnabled">
                                <div class="mb-3">
                                    <message :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message>
                                </div>
                                <div class="subtitle">
                                    <!-- <img src="../../../../static/fxView/images/fxview_logo.svg" alt="Logo"> -->
                                    <h3>Login to Fxview IB portal</h3>
                                </div>
                                <div class="stepForm">
                                    <div class="form-group field-wrapper">
                                        <div class="position-relative">
                                            <input placeholder=" " type="text" v-model="email" name="Email" class="float-field form-control"  v-validate="'required|email'"   :class="{ 'is-invalid': submitted && errors.has('Email') }" ref="emailInput"/>
                                            <label class="float-label">Email</label>
                                        </div>
                                        <p v-for="error in errors.collect('Email')" class="error">{{ error }}</p>
                                        <feather type="mail" class="mailTo"></feather>
                                    </div>
                                    <div class="form-group field-wrapper">
                                        <div class="position-relative">
                                            <input placeholder=" " :type="inputtype" v-model="password" name="Password" class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/,'~])(?=.*[!@#$%^&*])\S{6,24}$/}" :class="{ 'is-invalid': submitted && errors.has('Password') }" ref="passwordInput" v-on:keyup.enter="login" />
                                            <label class="float-label">Password</label>
                                        </div>
                                        <feather :type="iconType" class="mailTo" @click.prevent="switchVisibility"></feather>
                                        <p class="error" v-for="error in errors.collect('Password')">
                                            <span v-show="error == 'The Password field is required.'">{{$t('reg_passwordFieldReq')}}</span>
                                            <span v-show="error == 'The Password field format is invalid.'">{{$t('reg_passCharVal')}}</span>
                                        </p> 
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="signupbtn full-width submitButton d-flex align-items-center justify-content-between w-100">
                                        <button class="prism_btn sm_btn" @click.prevent="login()">LOGIN </button>
										<div class="forgot_sec d-flex justify-content-end">
    										<router-link :to="'/forgot-password'" class="forgotpassword d-flex align-items-center">
    											<feather type="lock" class="mr-1"></feather> Forgot Password 
    										</router-link>    
    									</div>
                                    </div>
                                    <div class="forgot_sec text-left mt-4">
                                            <p>Don’t have an account?  <router-link :to="'/register'"> Sign up Here</router-link></p>    
                                        </div> 
                                    <div class="text-left mt-3 border-top pt-3 customnewcheckbox">
										<p class="f-12">Charlgate SVG LLC is a company registered in the St Vincent and the Grenadines with company registration number 1112 LLC 2021.</p>
									</div>
                                </div>            
                            </div>
                            <div class="sign_insec" v-else>
                                <div class="mb-3">
                                    <message :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message>
                                </div>
                                <div class="subtitle w-100">
                                    <h3 class="mb-3">Two-step Verification</h3>
                                    <p class="mb-4">Please enter the one time passcode shown in the <strong>Google Authenticator</strong> app.</p>
                                </div>
                                <div class="form-group field-wrapper">
                                    <div class="position-relative">
                                        <input   placeholder=" " type="text" name="code" v-model="code" class="float-field form-control"  v-validate="'required'"   :class="{ 'is-invalid': submittedCode && errors.has('code') }" ref="codeInput" />
                                        <label for="username"  class="float-label">Enter Authentication Code</label>
                                    </div>
                                    <p class="error" v-for="error in errors.collect('code')">{{ error }}</p>
                                </div>
                                <div class="clearfix"></div>
                                <div class="d-flex justify-content-between align-items-center submitButton w-100">
                                    <div class="forgot_sec">
                                        <a href="#" class="forgotpassword d-flex align-items-center" @click.prevent="gAuthenticatorEnabled = false;clearMessage()">    
                                            <feather type="lock" class="mr-1"></feather> Back to log in page 
                                        </a>    
                                    </div>
                                    <button class="prism_btn btn_sm" @click.prevent="submitCode()"> Submit</button> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    var CryptoJS = require("crypto-js"); 
    const crypto = require('crypto');
    import { fxViewMixins } from '@/plugins/fxView'
    import * as types from '@/types'
    import { mapActions } from 'vuex'  
    export default {
        name: 'LOGIN',
        mixins: [fxViewMixins],
        data(){     
            return {
                email:"",
                password:"",  
                response_msg : '',
                msg_type : '',
                message_type : '',  
                pageLoader : false,
				submitted : false,
				showpassword : false,
				iconType : 'eye-off',
                inputtype : 'password',

                code : '',
                submittedCode : false,
                gAuthenticatorEnabled : false
            }
        },
        methods:{
            ...mapActions({
                _runLogin: types.RUN_USER_LOGIN,
                _runUserLogin2FA: types.RUN_USER_LOGIN_2FA,
                _runstateLoad: types.RUN_STATE_LOAD
            }),
			switchVisibility() {
                this.showpassword = !this.showpassword
                if(this.showpassword){
                    this.inputtype = 'text'
                    this.iconType = 'eye'
                }else{
                    this.inputtype = 'password'
                    this.iconType = 'eye-off'
                } 
            },
            login(){
				
                const _that = this
				_that.submitted = true;
				_that.$validator.validate().then(valid => {
                    if (valid) {
                        let inputJson={
                            'globalParams':{
                                "email": _that.email,
                                "password": _that.password,
                            },
                            'localParams' : {
                                'parameter' : _that
                            }
                        }
                        _that._runLogin(inputJson)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            submitCode(){
                const _that = this
                _that.submittedCode = true;
                
                const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(_that.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');
                
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                "google_token" : _that.code.toString(),
                                "email": _that.email,
                                "password": hashedstr
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runUserLogin2FA(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        },
        created(){
            if(this.$route.query.token){
                let user = {
                    "password":"",
                    "email":"",
                    "username":"",
                    "client_code":"",
                    "profile":{},
                    "token":this.$route.query.token,
                    "loggedIn":true
                }
                
                localStorage.setItem('user', btoa(JSON.stringify(user)))
                this._runstateLoad({'globalParams' :{},'localParams' :{ "parameter" : this,'page' : 'indexVue' }})
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/fxView/users/login.vue